import React from 'react';
import classNames from 'classnames';
import {GlobalVersionData} from '../../../hooks/global-version/use-global-version-query';
import styles from './query-layout.module.css';
import {isEditableQueryDraft} from '../utils';
import {QueryEditor} from './query-editor/query-editor';
import {useSidebarTabs} from '../../../hooks/use-sidebar-tabs';

interface Props {
    selectedQuery: StoppedQuery | FailedQuery | DraftQuery | PendingQuery | RunningQuery;
    globalVersions: GlobalVersionData[];
    sidebarTabsProps: ReturnType<typeof useSidebarTabs>;
}

export function NonCompletedQueryContent(props: Props) {
    return (
        <div
            className={classNames(styles.queryLayout, {
                [styles.viewMode]: !isEditableQueryDraft(props.selectedQuery)
            })}
        >
            <QueryEditor
                isCollapsed={false}
                toggleIsCollapsed={() => null}
                selectedQuery={props.selectedQuery}
                globalVersions={props.globalVersions}
                sidebarTabsProps={props.sidebarTabsProps}
            />
        </div>
    );
}
